import React, { Component } from 'react';
import styled from 'styled-components';

import { Font, FontWeight } from '../../../utils/fonts';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import validateName from '../validateName';

class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: true,
            isOnFocus: false,
            contactError: false,
            message: 'Некорректный E-mail',
        };

        this.checkRequiredValidity = this.checkRequiredValidity.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
    }

    checkValueLength(event) {
        const { errorMessage: defaultErrorMessage } = this.props;
        const { value } = event.target;
        if (value.length === 0) {
            this.setState({ isValid: false, message: defaultErrorMessage });
        } else if (value.length < 2) {
            this.setState({ isValid: false, contactError: true, message: 'Проверьте введённые данные' });
        } else if (!validateName(value)) {
            this.setState({ isValid: false, contactError: true, message: 'Проверьте введённые данные' });
        } else {
            this.setState({ isValid: true });
        }
    }

    handleOnBlur(event) {
        this.setState({ isOnFocus: false });

        this.checkRequiredValidity(event);
        this.checkValueLength(event);
        this.checkEmailValidity(event);
        this.checkPhoneValidity(event);
    }

    handleOnFocus() {
        this.setState({ isOnFocus: true });
    }

    handleOnChange(event) {
        const { onChange } = this.props;
        onChange(event);
        this.checkValueLength(event);
        this.checkRequiredValidity(event);
        // this.checkEmailValidity(event);
    }

    checkRequiredValidity(event) {
        const { required } = this.props;
        if (required) {
            if (event.target.value <= 0) {
                this.setState({ isValid: false });
            } else {
                this.setState({ isValid: true });
            }
        } else {
            this.setState({ isValid: true });
        }
    }

    checkEmailValidity(event) {
        const { type } = this.props;
        if (type === 'email') {
            if (event.target.value <= 0) {
                this.setState({ isValid: false, contactError: false });
            } else {
                /* eslint-disable */
                const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (event.target.value.match(emailPattern)) {
                    this.setState({ isValid: true, contactError: false });
                } else {
                    this.setState({ isValid: false, contactError: true });
                }
                /* eslint-enable */
            }
        }
    }

    checkPhoneValidity(event) {
        const { type } = this.props;
        if (type === 'phone') {
            if (event.target.value <= 0) {
                this.setState({ isValid: false, contactError: false });
            } else {
                /* eslint-disable */
                // const phonePattern = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/;
                const phonePattern = /^\+7\([0-9]{3}\)[0-9]{3}-[0-9]{2}-[0-9]{2}$/i;
                if (event.target.value.match(phonePattern)) {
                    this.setState({ isValid: true, contactError: false });
                } else {
                    this.setState({ isValid: false, contactError: true, message: 'Некорректный телефон' });
                }
                /* eslint-enable */
            }
        }
    }

    render() {
        const {
            className,
            lable,
            value,
            type,
            errorMessage,
            required,
        } = this.props;

        const {
            isValid,
            isOnFocus,
            contactError,
            message,
        } = this.state;

        return (
            <>
                <Root className={className} isValid={isValid}>
                    <InputBasic
                        className={className}
                        onChange={(event) => this.handleOnChange(event)}
                        onBlur={(event) => this.handleOnBlur(event)}
                        onFocus={(event) => this.handleOnFocus(event)}
                        type={type}
                        value={value}
                        required={required}
                        isValid={isValid}
                        maxLength="32"
                    />
                    <LabelStyled
                        value={value}
                        isOnFocus={isOnFocus}
                        className="headline"
                        isValid={isValid}
                    >
                        {lable}
                    </LabelStyled>
                </Root>
                <ErrorMessage isValid={isValid}>
                    {
                        contactError ? message : errorMessage
                    }
                </ErrorMessage>
            </>
        );
    }
}

const Root = styled.div`
    position: relative;
    height: 97px;

    input:focus+label {
            color: ${({ isValid }) => (isValid ? '#0032A0' : '#FF5A55')};
        }
    
    ${mediaWidth.m} {
        height: 85px;

        margin-top: 10px;
        &:first-child {
            margin-top: 40px;
        }
    }

    ${mediaWidth.l} {
        input:hover+label {
            color: ${({ isValid }) => (isValid ? '#0032A0' : '#FF5A55')};
        }
    }
`;

const InputBasic = styled.input`
    position: absolute;
    bottom: 0px;
    width: 100%;

    padding: 0px 0px 12px 0px;

    border: none;
    border-radius: 0px;
    border-bottom: ${({ isValid }) => (isValid ? '1px solid rgba(0, 0, 0, .16)' : '1px solid #FF5A55')};
    background: transparent;

    outline: none;

    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 18px;
    line-height: 23px;

    color: ${({ isValid }) => (isValid ? 'rgba(0, 0, 0, .64)' : '#FF5A55')};

    :focus {
        border-bottom: ${({ isValid }) => (isValid ? '1px solid #0032A0' : '1px solid #FF5A55')};
    }

    z-index: 2;
`;

const LabelStyled = styled.label`
    position: absolute;
    bottom: ${({ isOnFocus, value }) => ((isOnFocus) || (value.length > 0) ? '43px' : '12px')};

    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: ${({ isOnFocus, value }) => ((isOnFocus) || (value.length > 0) ? '16px' : '18px')};
    line-height: 21px;

    color: ${({ isValid, value }) => ((!isValid && '#FF5A55') || (isValid && value && '#0032A0')) || 'rgba(0, 0, 0, .4)'};

    transition: all 0.2s;
    backface-visibility: hidden;

    :hover {
            color: ${({ isValid }) => (isValid ? '#0032A0' : '#FF5A55')};
        }
`;

const ErrorMessage = styled.div`
    margin-top: 8px;

    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 12px;
    line-height: 16px;

    color: #FF5A55;

    opacity: ${({ isValid }) => (isValid ? '0' : '1')};
    transition: opacity 0.2s;
`;

export default Input;
